import { useCallback, useState } from 'react';
import { useQuery } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { VIDEO_INTEGRATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { createQueriedURL } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IVODVideo } from '~/Models/DTO/VideoOnDemand.models';

export const useRequestVODVideos = (params: Record<string, string | number | boolean>) => {
  const { currentProvider } = useProvider();
  const providerId = currentProvider?.uuid;
  const [responseHeaders, setResponseHeaders] = useState();
  const retrieveResponseHeader = useCallback(setResponseHeaders, []);

  const response = useQuery<IVODVideo[], IErrorResponse>(
    [REQUEST_ACTIONS.GET_VOD_VIDEOS, providerId, params],
    async () =>
      requestReactQuery<IVODVideo[]>({
        url: createQueriedURL(VIDEO_INTEGRATION_SERVICE_URLS.VOD_VIDEOS, {
          providerId,
          params,
        }),
        config: { method: 'GET' },
        retrieveResponseHeader,
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: TIME_VALUES.HOUR,
    },
  );

  return {
    ...response,
    responseHeaders,
  };
};
